// Deterministic demo stock so every location shows the same products between renders.
const PRODUCTS = {
  dry: ['Rice 20kg', 'Flour 25kg', 'Canned Tomato', 'Pasta 5kg', 'Sugar 10kg', 'Cooking Oil 4L'],
  chilled: ['Milk 2L', 'Cheese Block', 'Yoghurt Tub', 'Butter 500g', 'Fresh Salad Pack'],
  frozen: ['Frozen Peas', 'Chicken Wings', 'Ice Cream 4L', 'Fish Fillets', 'Frozen Chips'],
};

const hash = (s) => [...s].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);

export const getStock = (locationCode, zoneKey) => {
  const h = hash(locationCode);
  if (h % 5 === 0) return []; // some locations are empty
  const list = PRODUCTS[zoneKey];
  const count = 1 + (h % 3);
  return Array.from({ length: count }, (_, i) => ({
    name: list[(h + i) % list.length],
    qty: 5 + ((h >>> (i + 1)) % 40),
  }));
};
